import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { TagDetailOption } from './getTagDetails'

// PUT replaces an existing value in place.
const updateTagDetailValue = async (
	tagDetailName: string,
	tagDetailValue: TagDetailOption,
	newTagDetailValue: TagDetailOption
): Promise<void> => {
	const response = await fetchWithAuthorizationHeader(
		`${CONSTANT.TAG_DETAILS_API_URL}?tagDetailName=${encodeURIComponent(
			tagDetailName
		)}`,
		{
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ tagDetailName, tagDetailValue, newTagDetailValue })
		}
	)

	if (response.ok) return
	if (response.status === 403) {
		throw new Error('Not authorized to rename platforms (PUT /tag-details was refused).')
	}
	if (response.status === 422) {
		throw new Error('This value no longer exists.')
	}
	throw new Error('Request failed. Try again.')
}

export default updateTagDetailValue
